import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription, map, tap } from 'rxjs';
import { ScrollFocusService } from 'src/app/common/services/scroll-focus.service';
import { MktDynamicOfferService, MktModalService, MktSiteCatalystService } from 'src/app/core/services';
import { ClientPlatformService } from 'src/app/common/services';
import { PdpStackedSwipeZoneComponent } from '../pdp-stacked-swipe-zone/pdp-stacked-swipe-zone.component';
import { MktCommonModule } from 'src/app/common/mkt-common.module';

@Component({
  selector: 'app-header-section-box',
  templateUrl: './header-section-box.component.html',
  styleUrls: ['./header-section-box.component.scss'],
  standalone: true,
  imports: [MktCommonModule, PdpStackedSwipeZoneComponent]
})
export class HeaderSectionBoxComponent implements OnInit, OnDestroy {
  @Input() cardDetails: any;
  @Input() reviewContent: any = null;
  @Input() headerContent: any = null;
  @Input() hrefTarget = '_blank';
  @Input() prodName: string;
  @Output() anchorLinkClicked = new EventEmitter<any>();
  @Output() applyNowClicked = new EventEmitter<any>();
  @Output() callToApplyClicked = new EventEmitter<any>();
  @Output() pricingInfoClicked = new EventEmitter<any>();
  @Output() additionalInfoClicked = new EventEmitter<any>();
  boxWidth = 31;
  @ViewChild('calltoApply') calltoApply: ElementRef;
  cardApplyNowBtnLink: string;
  isCardArtReady = false;
  cardImageSize = 'xl';
  private dynamicOfferSub: Subscription = new Subscription();

  isMobileScreenSize$;
  isTabletAndBeyondSize$;
  isStackedSwipeZoneDisplayed$;

  isSwipeZoneEnable = true;
  @Output() taggingEmit = new EventEmitter<any>();

  constructor(
    private readonly mktSiteCatalystService: MktSiteCatalystService,
    private readonly scrollFocusService: ScrollFocusService,
    private readonly modalService: MktModalService,
    private readonly mktDynamicOfferService: MktDynamicOfferService,
    private readonly clientPlatformService: ClientPlatformService,
  ) {
    //  get the dynamic url
    this.dynamicOfferSub = this.mktDynamicOfferService.getApplyNowContent().subscribe((content) => {
      this.cardApplyNowBtnLink = content.applyNowUrl;
      this.isCardArtReady = true;
    });

    this.isMobileScreenSize$ = this.clientPlatformService.isMobileScreenSize$.pipe(map(width => width ? true : false));
    this.isTabletAndBeyondSize$ = this.clientPlatformService.isTabletAndBeyondSize$.pipe(map(width => width ? true : false));
  }
  ngOnInit(): void {
    this.setPromoBox();
    this._setStackedSwipeZoneDisplayFlags();
  }
  ngOnDestroy(): void {
    this.dynamicOfferSub.unsubscribe();
  }
  scrollToReviewSection(sectionId: string) {
    this.mktSiteCatalystService.callSC('ratingsAndReviewsClick', { 'ratingAndReviewDetail': this.prodName });
    this.scroll(sectionId);
    this.anchorLinkClicked.emit('Reviews');
  }
  isMobile() { return (window.innerWidth <= 480) }
  isDesktop() { return (window.innerWidth >= 1025) }
  isReOrder() { return (window.innerWidth > 480 && window.innerWidth < 768) }
  scroll(sectionId: string) {
    this.scrollFocusService.scrollFocus({}, sectionId, 'pdp');
  }
  openCallToApply(event: MouseEvent) {
    let callToApply = this.headerContent.callToApply;
    callToApply = {
      title: '',
      content: '',
      siteCatalyst: {},
      showCancelButton: false,
      cancelButtonText: callToApply.closeModalText,
      primaryButtonText: callToApply.closeModalText,
      url: '',
      useDefaults: false,
      children: callToApply.content
    };
    callToApply.genericTemplateContent = callToApply;
    const modalInstance = this.modalService.openModal(event, callToApply, false);

    if (true) {
      const handleOnClose = () => {
        (this.calltoApply.nativeElement as HTMLAnchorElement).focus();
        modalCloseSub.unsubscribe();
        modalContinueSub.unsubscribe();
        this.resizeModal();
      };

      // Subscribe to modal close emitter
      const modalCloseSub = !!modalInstance && modalInstance.onClose.subscribe(handleOnClose.bind(this));

      // Subscribe to modal continue emitter
      const modalContinueSub = !!modalInstance && modalInstance.onContinue.subscribe(handleOnClose.bind(this));

      this.resizeModal();
    }

    if (modalInstance) { this.callToApplyClicked.emit('callToApplyClicked') }

    return false;
  }

  private resizeModal(): void {
    const el = document.querySelector('.cds-modal-content') as HTMLElement;
    if (el) {
      let iWidth = '80vw';
      if (innerWidth <= 480) {
        iWidth = '100%';
      }
      else if (innerWidth > 1080) {
        iWidth = '50vw';
      }
      el.setAttribute('style', `width:${iWidth};margin: 10vw auto;`);
    };
  }

  @HostListener('window:resize', [])
  setPromoBox() {
    this.clientPlatformService.updateWindowWidth(window.innerWidth);
    if (this.isMobile()) {
      this.boxWidth = 100;
    } else {
      this.boxWidth = Math.ceil(100 / this.headerContent?.boxCount) - 3;
    }
    this.cardImageSize = (window?.innerWidth <= 480) ? 'lg' : 'xl';
    this.cardImageSize = (window?.innerWidth <= 480 && this.cardDetails.reOrder == true) ? 'sm' : 'xl';
  }

  anchorLink(value) {
    if (document.getElementById('Pricing').innerText) {
      const output = value.replace(/\+/g, '');
      this.anchorLinkClicked.emit(output);
    } else {
      this.anchorLinkClicked.emit(value);
    }
  }

  applyNow(event) {
    this.applyNowClicked.emit(event);
  }
  pricingInfo(event) {
    this.pricingInfoClicked.emit(event);
  }
  additionalInfo(event){
    this.additionalInfoClicked.emit(event);
  }

  private _setStackedSwipeZoneDisplayFlags() {
    if (this.headerContent) {
      this.isStackedSwipeZoneDisplayed$ = this.clientPlatformService.windowWidth$.pipe(map(width => {
        const displayOnMobile = width <= 768 && this.headerContent?.isStackedSwipeZoneDisplayed?.mobile ? true : false;
        const displayOnDesktop = width > 768 && this.headerContent?.isStackedSwipeZoneDisplayed?.desktop ? true : false;
        return { displayOnMobile, displayOnDesktop }
      }));
    }
  }
}
